import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { RegistrationService } from '@us-registration/data-access';
import { IpsMelissaValidation } from '@us-registration/util-models';
import { delay, map, Observable, of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApplianceDetailsSteppedFormValidatorsService {
  constructor(private readonly registrationService: RegistrationService) {}

  isEmailValid(errorMessage: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      return of(control.value).pipe(
        delay(500),
        switchMap((value: string) =>
          this.registrationService.registerEmailValidation(value).pipe(
            map((email: IpsMelissaValidation) =>
              email.isValid
                ? null
                : ({
                    emailInvalid: errorMessage,
                  } as ValidationErrors)
            )
          )
        )
      );
    };
  }

  isPhoneValid(errorMessage: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      return of(control.value).pipe(
        delay(500),
        switchMap((value: string) =>
          this.registrationService.registerPhoneNumberValidation(value).pipe(
            map((phone: IpsMelissaValidation) =>
              phone.isValid
                ? null
                : ({
                    phoneInvalid: errorMessage,
                  } as ValidationErrors)
            )
          )
        )
      );
    };
  }
}
